import React from 'react';
import styled from 'styled-components';
import {css} from 'emotion';
import Row from './Row.js'
import Swiper from 'react-id-swiper';
import "../../node_modules/react-id-swiper/src/styles/css/swiper.css";
import './custom-swiper.css';

/* global tw */

const Section = styled.section`
    ${tw`w-screen relative z-0 py-20 lg:py-28`};
    background: #0A0A0F;
    background-image:
        radial-gradient(ellipse 60% 40% at 50% 0%, rgba(170,11,202,0.12), transparent 65%),
        radial-gradient(ellipse 40% 30% at 90% 60%, rgba(125,14,222,0.08), transparent 70%);
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    overflow: hidden;
`

const Heading = styled.h2`
    ${tw`m-0 mb-12`};
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 800;
    color: #F5F5F7;
    letter-spacing: -0.035em;
    line-height: 1.1;
    font-size: 2rem;
    &::before {
        content: 'DESTINATIONS';
        display: block;
        text-transform: uppercase;
        letter-spacing: 0.12em;
        font-size: 0.6875rem;
        font-weight: 700;
        color: #CB53D1;
        margin-bottom: 0.875rem;
    }
    &::after {
        content: '';
        display: block;
        margin-top: 0.875rem;
        height: 2px;
        width: 2.5rem;
        background: #C9A84C;
        border-radius: 2px;
    }
    span {
        ${tw`block`};
        font-weight: 800;
        background: linear-gradient(135deg, #F5F5F7 0%, #CB53D1 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        letter-spacing: -0.04em;
    }
    @media (min-width: 992px){
        font-size: 2.75rem;
    }
`

const CityCard = styled.div`
    ${tw`relative flex flex-col justify-between overflow-hidden cursor-pointer`};
    background: #1A1A24;
    border: 1px solid rgba(170,11,202,0.2);
    border-radius: 6px;
    padding: 2rem 1.75rem 1.75rem;
    min-height: 16rem;
    width: 20rem;
    transition: all 0.28s ease;
    box-shadow: 0 4px 24px rgba(0,0,0,0.3);
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        background: linear-gradient(90deg, #AA0BCA, #5500DB);
        opacity: 0;
        transition: opacity 0.28s ease;
    }
    &:hover {
        border-color: rgba(170,11,202,0.4);
        transform: translateY(-6px);
        box-shadow: 0 20px 48px rgba(170,11,202,0.18);
    }
    &:hover::before {
        opacity: 1;
    }
    @media (min-width: 992px){
        width: 22rem;
    }
`

const CityName = styled.h3`
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 800;
    font-size: 2rem;
    color: #F5F5F7;
    letter-spacing: -0.04em;
    line-height: 1;
    margin: 0 0 0.5rem 0;
`

const CityTagline = styled.p`
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 400;
    font-size: 0.9375rem;
    color: #9898A8;
    letter-spacing: -0.005em;
    line-height: 1.5;
    margin: 0;
    flex: 1;
    margin-top: 0.5rem;
`

const CityBadge = styled.span`
    display: inline-block;
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 600;
    font-size: 0.6875rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #CB53D1;
    background: rgba(170,11,202,0.1);
    border: 1px solid rgba(170,11,202,0.2);
    border-radius: 4px;
    padding: 0.3rem 0.625rem;
    margin-bottom: 1.25rem;
`

const CityFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid rgba(170,11,202,0.12);
`

const FromPrice = styled.p`
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 500;
    font-size: 0.8125rem;
    color: #5A5A6E;
    margin: 0;
    span {
        font-weight: 700;
        color: #F5F5F7;
        font-size: 1rem;
    }
`

const Arrow = styled.span`
    font-size: 1.125rem;
    color: #AA0BCA;
    transition: transform 0.2s ease;
    ${CityCard}:hover & {
        transform: translateX(4px);
    }
`

const destinations = [
    {
        city: "Hyderabad",
        tagline: "Gateway to the Deccan. Explore Charminar, Golconda & beyond.",
        badge: "Outstation Cabs",
        from: "₹1,499",
    },
    {
        city: "Bangalore",
        tagline: "India's Silicon Valley. Seamless rides across the garden city.",
        badge: "Self Drive & Chauffeur",
        from: "₹1,299",
    },
    {
        city: "Goa",
        tagline: "Sun, sand & freedom. The ultimate road trip destination.",
        badge: "Outstation Cabs",
        from: "₹3,499",
    },
    {
        city: "Chennai",
        tagline: "The cultural capital of South India. Ride in comfort.",
        badge: "Airport Transfers",
        from: "₹999",
    },
    {
        city: "Mumbai",
        tagline: "The city that never sleeps. Premium rides, any hour.",
        badge: "Hourly Rentals",
        from: "₹1,799",
    },
    {
        city: "Delhi",
        tagline: "The heart of India. Travel with ease across the capital.",
        badge: "Outstation Cabs",
        from: "₹1,599",
    },
];

class SectionTwo extends React.Component {
    constructor(props) {
        super(props);
        this.swiper = React.createRef();
    }

    render() {
        const swiperOptions = {
            spaceBetween: 24,
            slidesPerView: 'auto',
            setWrapperSize: true,
            observer: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 16,
                },
                480: {
                    slidesPerView: 1.5,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 2.2,
                    spaceBetween: 24,
                },
            },
        };

        return (
            <Section>
                <Row>
                    <Heading>
                        How about these <span>Popular destinations?</span>
                    </Heading>
                </Row>
                <div className={css`padding: 0 1.5rem;`}>
                    <Swiper {...swiperOptions} ref={this.swiper}>
                        {destinations.map((dest, i) => (
                            <div key={i} className={css`width: auto !important;`}>
                                <CityCard>
                                    <div>
                                        <CityBadge>{dest.badge}</CityBadge>
                                        <CityName>{dest.city}</CityName>
                                        <CityTagline>{dest.tagline}</CityTagline>
                                    </div>
                                    <CityFooter>
                                        <FromPrice>
                                            From <span>{dest.from}</span>
                                        </FromPrice>
                                        <Arrow>→</Arrow>
                                    </CityFooter>
                                </CityCard>
                            </div>
                        ))}
                    </Swiper>
                </div>
            </Section>
        );
    }
}

export default SectionTwo;
